import * as yup from 'yup'
import conditionsRequired from './conditionsRequired'
import dateOfBirthMinMax from './dateOfBirthMinMax'
import emailRequired from './emailRequired'
import fileRequired from './fileRequired'
import required from './required'
import requiredMixed from './requiredMixed'
import salutationRequired from './salutationRequired'
import signatureRequired from './signatureRequired'
import stringRequiredMax from './stringRequiredMax'
export const Validator = (fields: any) => yup.object().shape(fields)

export {
  conditionsRequired,
  dateOfBirthMinMax,
  emailRequired,
  fileRequired,
  required,
  requiredMixed,
  salutationRequired,
  signatureRequired,
  stringRequiredMax,
}
